import Base from '@studiometa/js-toolkit/abstracts/Base';
import scrollTo from '../utils/scrollTo';

/**
 * Scroll component
 */
export default class ScrollTo extends Base {
  /**
   * Component Configuration
   */
  get config() {
    return {
      name: 'ScrollTo',
    };
  }

  /**
   * Calculate everything
   * @return {void}
   */
  mounted() {
    const pathArray = (
      window.location.pathname +
      window.location.search +
      window.location.hash
    ).split('/');

    const pageNumberRegex = /\d+(?=\?|#|)/;
    const fullRegex = /\d+\?\w+#/g;
    const shortRegex = /\d+(?=#)/g;

    // eslint-disable-next-line
    pathArray.forEach(function (path) {
      const pageNumber = parseInt(path.match(pageNumberRegex), 10);
      const formFiltersHeight =
        document.querySelector('.form-filters__container').offsetHeight || 0;
      const additionalFiltersHeight =
        document.querySelector('.form-filters__radios').offsetHeight || 0;

      if (pageNumber > 1 && (path.match(fullRegex) || path.match(shortRegex))) {
        scrollTo('.js-scroll-to-on-load', {
          offset: (formFiltersHeight + additionalFiltersHeight) * -1,
        });
      }
    });
  }
}
